import { SagaIterator } from 'redux-saga'
import { put } from 'redux-saga/effects'

import { LPAction, lpActions } from '~state/store'

export function* onProvideLiqudityExecuted(): SagaIterator {
  yield put(lpActions.setFormState(LPAction.Home))
}
